import get from 'lodash/get'
import { Map } from 'immutable'
import { getLanguages as apiGetLanguages } from './apis/languages'
import { getNode } from '../../node'

import {
  createSubscription as apiCreateSubscription,
  deleteSubscription as apiDeleteSubscription,
  updateSubscription as apiUpdateSubscription,
  getSubscriptions as apiGetSubscriptions,
  getSubscription as apiGetSubscription,
} from './apis/subscriptions'

import {
  getNotificationTypes as apiGetNotificationTypes,
  createNotification as apiCreateNotification,
  deleteNotification as apiDeleteNotification,
  updateNotification as apiUpdateNotification,
  getNotifications as apiGetNotifications,
  getNotification as apiGetNotification,
} from './apis/notifications'

import {
  CREATE_SUBSCRIPTION,
  REMOVE_SUBSCRIPTION,
  UPDATE_SUBSCRIPTION,
  CREATE_NOTIFICATION,
  REMOVE_NOTIFICATION,
  UPDATE_NOTIFICATION,
  GET_SUBSCRIPTIONS,
  GET_NOTIFICATIONS,
  GET_NOTIFICATION,
  GET_SUBSCRIPTION,
  GET_RESTRICTIONS,
  GET_CONFIG,
  setSubscriptions,
  setNotifications,
  setNotification,
  setSubscription,
  setRestrictions,
  setConfig,
  setError,
} from './actions'

const log = console

async function getConfig ({ store }) {
  const { config, auth } = store.getState()
  try {
    const languages = await apiGetLanguages({
      server: config.getIn(['data', 'servers', 'brooklyn']),
      auth,
    })
    const types = await apiGetNotificationTypes({
      server: config.getIn(['data', 'servers', 'brooklyn']),
      auth,
    })
    store.dispatch(setConfig({
      subscritptionContentTypes: get(types, 'SUBSCRIPTION_CONTENT_TYPES'),
      notificationContentTypes: get(types, 'NOTIFICATION_CONTENT_TYPES'),
      notificationTypes: get(types, 'NOTIFICATION_TYPES'),
      subscriptionTypes: get(types, 'SUBSCRIPTION_TYPES'),
      languages,
    }))
  } catch (error) {
    log.error(error, 'Error getting languages.')
  }
}

async function getRestrictions ({ store, action }) {
  const { config } = store.getState()
  const { payload = {} } = action
  const { contentId } = payload
  try {
    const node = await getNode({
      server: config.getIn(['data', 'servers', 'brooklyn']),
      nid: contentId,
    })
    const restrictions = node.getIn(['feature', 'georestrictions'], Map())
    store.dispatch(setRestrictions(contentId, restrictions))
  } catch (error) {
    log.error(error, 'Error fetching node.')
    store.dispatch(setError('Could not fetch node'))
  }
}

async function createSubscription ({ store, action }) {
  const { config, auth } = store.getState()
  const { payload = {} } = action
  const { attributes = {}, type } = payload
  try {
    await apiCreateSubscription({
      server: config.getIn(['data', 'servers', 'brooklyn']),
      attributes,
      auth,
    })
    const subscriptions = await apiGetSubscriptions({
      server: config.getIn(['data', 'servers', 'brooklyn']),
      type,
      auth,
    })
    store.dispatch(setSubscriptions(subscriptions))
  } catch (error) {
    log.error(error, 'Error creating subscription.')
    const message = get(error, ['response', 'body', 'errors', 0, 'meta'], 'Could not create subscription.')
    store.dispatch(setError(message))
  }
}

async function updateSubscription ({ store, action }) {
  const { config, auth } = store.getState()
  const { payload = {} } = action
  const { attributes = {}, type } = payload
  try {
    await apiUpdateSubscription({
      server: config.getIn(['data', 'servers', 'brooklyn']),
      attributes,
      auth,
    })
    const subscriptions = await apiGetSubscriptions({
      server: config.getIn(['data', 'servers', 'brooklyn']),
      type,
      auth,
    })
    store.dispatch(setSubscriptions(subscriptions))
  } catch (error) {
    log.error(error, 'Error creating subscription.')
    const message = get(error, ['response', 'body', 'errors', 0, 'meta'], 'Could not update subscription.')
    store.dispatch(setError(message))
  }
}

async function removeSubscription ({ store, action }) {
  const { config, auth } = store.getState()
  const { payload = {} } = action
  const { id = {}, type } = payload
  try {
    await apiDeleteSubscription({
      server: config.getIn(['data', 'servers', 'brooklyn']),
      id,
      auth,
    })
    const subscriptions = await apiGetSubscriptions({
      server: config.getIn(['data', 'servers', 'brooklyn']),
      type,
      auth,
    })
    store.dispatch(setSubscriptions(subscriptions))
  } catch (error) {
    log.error(error, 'Error creating subscription.')
    const message = get(error, ['response', 'body', 'errors', 0, 'meta', 0], 'Could not delete subscription.')
    store.dispatch(setError(message))
  }
}

async function getSubscription ({ store, action }) {
  const { config, auth } = store.getState()
  const { payload = {} } = action
  const { id } = payload
  try {
    const subscription = await apiGetSubscription({
      server: config.getIn(['data', 'servers', 'brooklyn']),
      auth,
      id,
    })
    store.dispatch(setSubscription(subscription))
  } catch (error) {
    log.error(error, 'Error creating subscription.')
  }
}

async function getSubscriptions ({ store, action }) {
  const { config, auth } = store.getState()
  const { payload = {} } = action
  const { p = 1, pp = 200, type } = payload
  const server = config.getIn(['data', 'servers', 'brooklyn'])
  try {
    const subscriptions = await apiGetSubscriptions({
      server, type, auth, pp, p,
    })
    store.dispatch(setSubscriptions(subscriptions))
  } catch (error) {
    log.error(error, 'Error creating subscription.')
  }
}

async function createNotification ({ store, action }) {
  const { config, auth } = store.getState()
  const { payload = {} } = action
  const { attributes = {}, type } = payload
  const server = config.getIn(['data', 'servers', 'brooklyn'])
  try {
    await apiCreateNotification({ server, attributes, auth })
    const notifications = await apiGetNotifications({ server, type, auth })
    store.dispatch(setNotifications(notifications))
  } catch (error) {
    log.error(error, 'Error creating notification.')
    const message = get(error, ['response', 'body', 'errors', 0, 'meta'], 'Could not create notification.')
    store.dispatch(setError(message))
  }
}

async function updateNotification ({ store, action }) {
  const { config, auth } = store.getState()
  const { payload = {} } = action
  const { attributes = {}, type } = payload
  const server = config.getIn(['data', 'servers', 'brooklyn'])
  try {
    await apiUpdateNotification({ server, attributes, auth })
    const notifications = await apiGetNotifications({ server, type, auth })
    store.dispatch(setNotifications(notifications))
  } catch (error) {
    log.error(error, 'Error creating notification.')
    const message = get(error, ['response', 'body', 'errors', 0, 'meta'], 'Could not update notification.')
    store.dispatch(setError(message))
  }
}

async function removeNotification ({ store, action }) {
  const { config, auth } = store.getState()
  const { payload = {} } = action
  const { id = {}, type } = payload
  const server = config.getIn(['data', 'servers', 'brooklyn'])
  try {
    await apiDeleteNotification({ server, id, auth })
    const notifications = await apiGetNotifications({ server, type, auth })
    store.dispatch(setNotifications(notifications))
  } catch (error) {
    log.error(error, 'Error creating notification.')
    const message = get(error, ['response', 'body', 'errors', 0, 'meta', 0], 'Could not delete notification.')
    store.dispatch(setError(message))
  }
}

async function getNotification ({ store, action }) {
  const { config, auth } = store.getState()
  const { payload = {} } = action
  const { id } = payload
  try {
    const notification = await apiGetNotification({
      server: config.getIn(['data', 'servers', 'brooklyn']),
      auth,
      id,
    })
    store.dispatch(setNotification(notification))
  } catch (error) {
    log.error(error, 'Error getting notification.')
  }
}

async function getNotifications ({ store, action }) {
  const { config, auth } = store.getState()
  const { payload = {} } = action
  const { p = 1, pp = 20, type } = payload
  const server = config.getIn(['data', 'servers', 'brooklyn'])
  try {
    const notifications = await apiGetNotifications({
      server, auth, type, pp, p,
    })
    store.dispatch(setNotifications(notifications))
  } catch (error) {
    log.error(error, 'Error getting notifications.')
  }
}

export default (store) => (next) => (action) => {
  const { type } = action
  switch (type) {
    case GET_CONFIG:
      getConfig({ store })
      break
    case GET_RESTRICTIONS:
      getRestrictions({ store, action })
      break
    case GET_SUBSCRIPTION:
      getSubscription({ store, action })
      break
    case GET_NOTIFICATION:
      getNotification({ store, action })
      break
    case CREATE_SUBSCRIPTION:
      createSubscription({ store, action })
      break
    case UPDATE_SUBSCRIPTION:
      updateSubscription({ store, action })
      break
    case REMOVE_SUBSCRIPTION:
      removeSubscription({ store, action })
      break
    case GET_SUBSCRIPTIONS:
      getSubscriptions({ store, action })
      break
    case CREATE_NOTIFICATION:
      createNotification({ store, action })
      break
    case UPDATE_NOTIFICATION:
      updateNotification({ store, action })
      break
    case REMOVE_NOTIFICATION:
      removeNotification({ store, action })
      break
    case GET_NOTIFICATIONS:
      getNotifications({ store, action })
      break
    default:
      break
  }
  next(action)
}
